// Booking status describes a reservation decision, never attendance.
export function bookingDateISO(value) {
  const match = /^(\d{2})-(\d{2})-(\d{4})$/.exec(value || '');
  if (!match) return null;
  const [, month, day, year] = match;
  const date = new Date(`${year}-${month}-${day}T00:00:00Z`);
  return Number.isNaN(date.getTime()) || date.toISOString().slice(0, 10) !== `${year}-${month}-${day}`
    ? null : `${year}-${month}-${day}`;
}

export function kyivDateISO(now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Kyiv', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
  const part = name => parts.find(item => item.type === name).value;
  return `${part('year')}-${part('month')}-${part('day')}`;
}

export function periodBounds(period, today = kyivDateISO()) {
  if (period === 'all') return { from: '', to: '' };
  const date = new Date(`${today}T00:00:00Z`);
  date.setUTCDate(date.getUTCDate() - Number(period) + 1);
  return { from: date.toISOString().slice(0, 10), to: today };
}

export function clientPhoneKey(value) {
  let digits = String(value || '').replace(/\D/g, '');
  if (/^00380\d{9}$/.test(digits)) digits = digits.slice(2);
  if (/^0\d{9}$/.test(digits)) digits = `38${digits}`;
  return digits;
}

export function bookingStatistics(requests, { from = '', to = '', trainer = null } = {}) {
  const clients = new Map(), trainers = new Map();
  const totals = { bookings: 0, confirmed: 0, cancelled: 0, pending: 0, clients: 0, repeatClients: 0, cancelRate: 0 };
  let invalidDates = 0;
  for (const [index, request] of requests.entries()) {
    if (trainer && request.trainer !== trainer) continue;
    const date = bookingDateISO(request.date);
    if (!date) { invalidDates++; continue; }
    if ((from && date < from) || (to && date > to)) continue;
    const status = request.status === 'success' ? 'confirmed' : request.status === 'failed' ? 'cancelled' : 'pending';
    totals.bookings++; totals[status]++;
    const phoneKey = clientPhoneKey(request.phone);
    const key = phoneKey || `request:${request._id || index}`;
    if (!clients.has(key)) clients.set(key, { key, phoneKey, name: '', phone: '', bookings: 0, confirmed: 0, cancelled: 0, pending: 0, lastDate: '', lastTime: '' });
    const client = clients.get(key);
    client.bookings++; client[status]++;
    if (date > client.lastDate || (date === client.lastDate && String(request.time || '') >= client.lastTime)) {
      client.name = [request.name, request.surname].filter(Boolean).join(' ').trim() || 'Без імені';
      client.phone = String(request.phone || ''); client.lastDate = date; client.lastTime = String(request.time || '');
    }
    const trainerKey = request.trainer || 'unknown';
    if (!trainers.has(trainerKey)) trainers.set(trainerKey, { id: trainerKey, bookings: 0, confirmed: 0, cancelled: 0, pending: 0 });
    const coach = trainers.get(trainerKey); coach.bookings++; coach[status]++;
  }
  const rows = [...clients.values()].map(client => ({ ...client, cancelRate: Math.round(client.cancelled / client.bookings * 100) }));
  totals.clients = rows.length;
  totals.repeatClients = rows.filter(client => client.bookings > 1).length;
  totals.cancelRate = totals.bookings ? Math.round(totals.cancelled / totals.bookings * 100) : 0;
  return { totals, clients: rows, trainers: [...trainers.values()], invalidDates };
}

export function rankClients(clients, metric, search = '') {
  const query = search.trim().toLocaleLowerCase('uk-UA');
  const digits = search.replace(/\D/g, '');
  return clients.filter(client => client[metric] > 0)
    .filter(client => !query || client.name.toLocaleLowerCase('uk-UA').includes(query) || client.phone.toLocaleLowerCase('uk-UA').includes(query) || (digits && client.phoneKey.includes(digits)))
    .sort((a, b) => b[metric] - a[metric] || b.bookings - a.bookings || a.name.localeCompare(b.name, 'uk-UA') || a.key.localeCompare(b.key));
}
